// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1cozM","clinicsSelect":"TableHeading_clinicsSelect___rYaz"};